import React from 'react'
import "./IPL.css"
import { Link } from 'react-router-dom'
import {HiLocationMarker} from "react-icons/hi"
import pdfLink from "../../assets/IPLRULES.docx"
const IPL = () => {
  return (
    <div className='ipl_container'>
    <div className="title">
        <h2>IPL AUCTION</h2>            
    </div>
    <div className="evt_data">
        <div className="left">
            {/* <img src={img1} alt="" /> */}
        </div>
        <div className="right">
            <div className="r_detail">
            <p>Mar 14,2023</p>
            <h2>IPL AUCTION(TEAM)</h2>
            </div>
            <div className="reg_data">
                <div className="flex-cont">
            <div className="evt_reg">
                <h2>Entry Fee : Rs. 400</h2>
                <div className="reg_btns">
                <Link to="https://forms.gle/1AK15mhL2j1MfvgN6" target="_blank" className="reg_btn">Register Now</Link>
                </div>
                </div>
            </div>
            <div className="desc">
                <h3>Description</h3>
                 <p>IPL Auction' is an event of the 
Entrepreneurship,
which allows 
participants to use their 
cricketing minds in order to 
build their dream team. 'IPL 
Auction' looks to cover 
cricketing as well as the 
analytical skills such as 
predicting, managing budgets 
and many more. 
This event also looks to bring 
out the cricketing genius 
hidden in all of us. A simple 
yet challenging event where teams participate to win prizes in the end.</p>
                 <Link to={pdfLink} target="_blank" className="reg_btn">Rules & Regulations</Link>
            </div>
            <div className="date">
                <h3>Date & Time</h3>
                <div className="date_data">
                    <h4>Mar 14,2023</h4>
                </div>
            </div>
            <div className="loc">
                <h3>Location</h3>
                <p> <HiLocationMarker/>College of Engineering and Technology,Akola</p>
            </div>
            <div className="team">
                <h3><span>Coordinator</span> Team</h3>
                <div className="staf_team">
                    <h4>Staff Co-ordinator</h4>
                    <p> Prof. Swapnil Bobde - 9096611214</p>
                </div>
                <div className="team_data">
                    <h4>Student Co-ordinator</h4>
                    <p>	Prabhat Chauhan -  9834497257</p>
                    <p>Sachin Yadav- 9511695232 </p>
              
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default IPL